import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

interface RootProtectedRouteProps {
  children: React.ReactNode;
}

const RootProtectedRoute: React.FC<RootProtectedRouteProps> = ({ children }) => {
  const { userProfile, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <div>Loading...</div>;
  }

  if (userProfile !== 'Root') {
    // Redirigir al dashboard si no es Root
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};

export default RootProtectedRoute;
